<div class="modal-header header-pdf-financiador">
  <h4 *ngIf="documento.name !== '_Pagare'" class="modal-title pull-left">{{documento.name.split('_').join(' ')}}</h4>
  <h4 *ngIf="documento.name === '_Pagare'" class="modal-title pull-left">{{documento.name.split('_').join(' ').replace('e', 'é')}}</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="cerrarModal()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ngx-extended-pdf-viewer
    [base64Src]="documento.data"
    backgroundColor="#ffffff"
    [height]="'80vh'"
    [useBrowserLocale]="true"
    [handTool]="false"
    [showHandToolButton]="true"
    [showDrawEditor]="false"
    [showTextEditor]="false"
    [showOpenFileButton]="false"
  >
  </ngx-extended-pdf-viewer>
</div>

